import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    // Simulate form submission
    setTimeout(() => {
      setIsLoading(false);
      setIsSuccess(true);
    }, 2000);
  };

  const handleMouseOver = (event) => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let interval = null;
    let iteration = 0;
    clearInterval(interval);

    interval = setInterval(() => {
      const input = event.target;
      input.innerText = input.innerText
        .split("")
        .map((letter, index) => {
          if (index < iteration) {
            return input.dataset.value[index];
          }
          return letters[Math.floor(Math.random() * 26)];
        })
        .join("");

      if (iteration >= input.dataset.value.length) {
        clearInterval(interval);
      }
      iteration += 1 / 3;
    }, 30);
  };

  return (
    <div id="contact" className="contact-body">
      <div id="contact-form-wrapper" className="contact-form-wrapper">
        <h2 className="contact-header">
          <span data-value="Contact" id="contact-header" onMouseOver={handleMouseOver}>Contact</span>
        </h2>
        <form id="contact-form" className="contact-form" onSubmit={handleSubmit}>
          <input type="hidden" name="contact_number" />
          <div className="contact-form-grid">
            <div className="contact-group">
              <input id="name" name="name" required type="text" className="contact-input" />
              <span className="contact-highlight"></span>
              <span className="contact-bar"></span>
              <label htmlFor="name" className="contact-label">Name</label>
            </div>
            <div className="contact-group">
              <input id="email" name="email" required type="text" className="contact-input" />
              <span className="contact-highlight"></span>
              <span className="contact-bar"></span>
              <label htmlFor="email" className="contact-label">Email</label>
            </div>
          </div>
          <div className="contact-group">
            <textarea id="message" name="message" required rows="4" className="contact-text-area"></textarea>
            <span className="contact-highlight"></span>
            <span className="contact-bar"></span>
            <label htmlFor="message" className="contact-label">Message</label>
          </div>
          <div className="contact-submit-button-wrapper">
            <button id="submit" type="submit">
              <div className="contact-svg-wrapper-1">
                <div className="contact-svg-wrapper">
                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z" fill="currentColor"></path>
                  </svg>
                </div>
              </div>
              <span>Send</span>
            </button>
            {isLoading && <span id="loading" className="contact-loading">sending ...</span>}
          </div>
        </form>
        {isSuccess && (
          <div id="success" className="contact-notification contact-success">
            <div className="contact-notification-content">
              <div className="contact-icon contact-success-icon">
                <svg className="contact-icon-svg" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 3.33331C10.8 3.33331 3.33337 10.8 3.33337 20C3.33337 29.2 10.8 36.6666 20 36.6666C29.2 36.6666 36.6667 29.2 36.6667 20C36.6667 10.8 29.2 3.33331 20 3.33331ZM16.6667 28.3333L8.33337 20L10.6834 17.65L16.6667 23.6166L29.3167 10.9666L31.6667 13.3333L16.6667 28.3333Z"></path>
                </svg>
              </div>
              <div className="contact-notification-text">
                <span className="contact-notification-title">Success</span>
                <p className="contact-notification-message">Your message was sent successfully!</p>
              </div>
            </div>
          </div>
        )}
        <div className="contact-info">
          <p>Email: <a href="mailto:dagimjalleta@gmail.com">dagimjalleta@gmail.com</a></p>
          <p>Phone: <a href="tel:+16823383744">+1 682 338 3744</a></p>
        </div>
      </div>
    </div>
  );
};

export default Contact;